import React, { useState, useEffect } from "react";
import Container from "@material-ui/core/Container";
import { connect } from "react-redux";
import Loading from "../Loading";
import NewOrders from "./newOrders/NewOrders";
import PreparableOrders from "./preparableOrders/PreparableOrders";
import DeliveringOrders from "./deliveringOrders/DeliveryingOrder";
import OrdersToDeliver from "./pendingToDeliver/OrdersToDeliver";

const MainPage = (props) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (props.auth.isAuthenticated) {
      setLoading(false);
    }
  }, [props.auth.isAuthenticated]);

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      <Container>
        <NewOrders />
        <PreparableOrders />
        <OrdersToDeliver />
        <DeliveringOrders />
      </Container>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps)(MainPage);
